const getKeyCode = (str) => {
  if (!str?.length) return 0
  return str.charCodeAt(0)
}

export { getKeyCode }
